import { Form } from "react-bootstrap";
import { RenderWhen } from "../../../../../../components";
import { isAdmin } from "../../../../../../utils";
import { SaveAsForm as SaveAsFormType } from "../../@types";

const admin = isAdmin();

type Props = {
  value: { name: string; type: string };
  onChange: (value: SaveAsFormType) => void;
};

const SaveAsForm = ({ value, onChange }: Props) => {
  const handleTypeChange = (type: string) => {
    onChange({
      ...value,
      type
    });
  };

  return (
    <Form
      className="flex flex-column flex-gap-4"
      onSubmit={event => {
        event.preventDefault();
      }}
    >
      <div>
        <Form.Label>Save Layout as:</Form.Label>
        <Form.Control
          value={value.name}
          onChange={event =>
            onChange({
              ...value,
              name: event.target.value
            })
          }
          type="text"
          placeholder="Enter Name"
        />
      </div>
      <RenderWhen condition={admin}>
        <div>
          <Form.Label>Layout Type:</Form.Label>
          <Form.Check inline name="type">
            <Form.Check.Input
              checked={value.type === "user"}
              type="radio"
              style={{ cursor: "pointer" }}
              onChange={() => handleTypeChange("user")}
            />
            <Form.Check.Label
              style={{ cursor: "pointer" }}
              onClick={() => handleTypeChange("user")}
            >
              Personal Layout
            </Form.Check.Label>
          </Form.Check>
          <Form.Check inline name="type">
            <Form.Check.Input
              checked={value.type === "shared"}
              type="radio"
              style={{ cursor: "pointer" }}
              onChange={() => handleTypeChange("shared")}
            />
            <Form.Check.Label
              style={{ cursor: "pointer" }}
              onClick={() => handleTypeChange("shared")}
            >
              Shared Layout
            </Form.Check.Label>
          </Form.Check>
        </div>
      </RenderWhen>
    </Form>
  );
};
export default SaveAsForm;
